<template>
  <NavBar />
  <main class="invite-page">
    <div class="container invite-container">
      <header class="invite-header">
        <img class="invite-hero-image" src="@/assets/images/invite/learn-together.svg" alt="" width="480" height="300" aria-hidden="true">
        <span class="eyebrow">BİRLİKTE ÖĞRENMEK DAHA GÜZEL</span>
        <h1>İngilizce yolculuğunuzu<br class="d-none d-sm-block"> arkadaşlarınızla paylaşın.</h1>
        <p>Sevdiklerinizi Lengedu ile tanıştırın, birlikte öğrenmenin ayrıcalıklarından yararlanın.</p>
      </header>
      <div class="invite-layout">
        <section aria-labelledby="benefits-title">
          <div class="reward-card">
            <img class="reward-image" src="@/assets/images/invite/reward-gift.svg" alt="" width="160" height="140" aria-hidden="true">
            <p class="eyebrow">SİZE KÜÇÜK BİR TEŞEKKÜR</p>
            <h2 id="benefits-title">1 ay hediye eğitim</h2>
            <p>Davetinizle kayıt olup derslere başlayan her arkadaşınız için 1 ay hediye eğitim ve %10 indirim çeki kazanabilirsiniz.</p>
            <div class="friend-benefit"><i class="bi bi-heart" aria-hidden="true"></i><span>Arkadaşınız da <strong>%10 indirimle</strong> kayıt olabilir.</span></div>
          </div>
          <div class="invite-steps">
            <h2>Nasıl ilerliyoruz?</h2>
            <ol>
              <li><span aria-hidden="true">1</span><div><h3>Arkadaşınızı davet edin</h3><p>Arkadaşınızın iletişim bilgilerini form aracılığıyla paylaşabilirsiniz.</p></div></li>
              <li><span aria-hidden="true">2</span><div><h3>Biz tanışalım</h3><p>Eğitim danışmanlarımız arkadaşınızla iletişime geçerek merak ettiklerini yanıtlasın.</p></div></li>
              <li><span aria-hidden="true">3</span><div><h3>Birlikte kazanın</h3><p>Arkadaşınız derslere başladığında siz de hediyenizden yararlanın. Davet sayısında sınır yok.</p></div></li>
            </ol>
          </div>
        </section>
        <section class="invite-form-card" aria-labelledby="form-title">
          <h2 id="form-title">Arkadaşınızı davet edin</h2>
          <p class="form-intro">Tanışmamıza vesile olduğunuz için teşekkür ederiz.</p>
          <form @submit.prevent="SubmitForm" novalidate :aria-busy="form.isLoading">
            <div class="name-fields">
              <div><label for="friend-name">Arkadaşınızın adı</label><input id="friend-name" v-model="form.name" type="text" class="form-control" placeholder="Adı" autocomplete="off"></div>
              <div><label for="friend-surname">Soyadı</label><input id="friend-surname" v-model="form.surname" type="text" class="form-control" placeholder="Soyadı" autocomplete="off"></div>
            </div>
            <div class="invite-field">
              <label for="friend-email">E-posta adresi</label>
              <input id="friend-email" v-model="form.email" type="email" class="form-control" placeholder="ornek@eposta.com" autocomplete="off" aria-describedby="contact-help">
            </div>
            <div class="phone-fields invite-field">
              <div><label for="friend-country">Ülke kodu</label><input id="friend-country" v-model="form.phoneCountryCode" type="tel" inputmode="numeric" class="form-control" maxlength="4" @keydown="checkDigit($event)"></div>
              <div><label for="friend-phone">Telefon numarası</label><input id="friend-phone" v-model="form.phoneNumber" type="tel" inputmode="numeric" class="form-control" placeholder="5XXXXXXXXX" maxlength="10" autocomplete="off" @keydown="checkDigit($event)" aria-describedby="contact-help"></div>
            </div>
            <p id="contact-help" class="contact-help">E-posta adresi veya telefon numarasından birini paylaşmanız yeterli.</p>
            <button type="submit" class="btn invite-submit" :disabled="form.isLoading">
              <span v-if="form.isLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <span>{{ form.isLoading ? 'Davetiniz gönderiliyor…' : 'Davet gönder' }}</span>
              <i v-if="!form.isLoading" class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>
            <p class="invite-note">Lütfen iletişim bilgilerini paylaşmadan önce arkadaşınızın iznini almayı unutmayın.</p>
          </form>
        </section>
      </div>
      <p class="campaign-note">%10 indirim çekinizi paket değişikliği, dakika artırımı, ikinci paket alımı ve program uzatma dahil tüm Lengedu hizmetlerinde kullanabilirsiniz.</p>
    </div>
  </main>
  <FormDialog
    :Title="dialog.title"
    :Content="dialog.content"
    :Visible="dialog.dialogModalVisible"
    :ShowAcceptButton="false"
    :ShowRefuseButton="false"
    @CloseModal="OpenCloseFormDialogModal($event)"
  />
  <FooterInPage />
</template>

<script>
import { mapActions } from "vuex";
import { LoadingToast,UpdateToast,ToastType } from "@/common/notification.js";
import {IsEmailValid} from "@/common/validation-email";
import FormDialog from "@/components/Modals/CustomDialogModal.vue";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
export default {
  name: 'InvitePage',
  data() {
    return {
      form:{
        isLoading:false,
        name:'',
        surname:'',
        phoneCountryCode:'0090',
        phoneNumber:'',
        email:''
      },
      dialog:{
        title:'',
        content:'',
        dialogModalVisible:false,
      }
    };
  },
  components: {
    NavBar,
    FooterInPage,
    FormDialog
  },
  computed:{
  },
  methods: {
    ...mapActions(["RegisterReferenceForm"]),
    async SubmitForm(){
      if (this.form.isLoading) return;
      if(this.form.phoneNumber.length<10 && !IsEmailValid(this.form.email))
      {
          this.dialog.content="Lütfen arkadaşınızın geçerli bir e-posta adresini veya 10 haneli telefon numarasını paylaşın.";
          this.dialog.title="İletişim bilgisini tamamlayabilir misiniz?";
          this.OpenCloseFormDialogModal(true);
          return;
      }
      
      this.form.isLoading=true;
      let toastId = LoadingToast();
      let model = {
        name: this.form.name,
        surname: this.form.surname,
        phoneCountryCode: this.form.phoneCountryCode,
        phoneNumber: this.form.phoneNumber,
        email: this.form.email,
        utmSource: 'student.lengedu.com',
        utmMedium: '',
        utmContent: 'referans-form',
        utmCampaign: '',
        utmTerm: ''
      }
      await this.RegisterReferenceForm(model)
      .then((res)=>{
        this.form.isLoading=false;
        UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
        this.clearForm();
      })
      .catch((err)=>{
        this.form.isLoading=false;
        UpdateToast(toastId,err.message,ToastType().ERROR);
      });
    },
    checkDigit(event){
      if (event.key.length === 1 && isNaN(Number(event.key))) {
        event.preventDefault();
      }
    },
    OpenCloseFormDialogModal(visible){
      this.dialog.dialogModalVisible=visible;
    },
    clearForm(){
      this.form.name='';
      this.form.surname='';
      this.form.phoneCountryCode='0090';
      this.form.phoneNumber='';
      this.form.email='';
    }
  },
  mounted: function() {
  }
}
</script>
<style scoped>
.invite-page { background: radial-gradient(ellipse at 50% 0, #edf3e7 0, transparent 55%), #f7f9f7; color: #24382e; padding: 28px 0 36px; }
.invite-container { max-width: 1080px; }
.invite-header { max-width: 700px; margin: 0 auto 40px; text-align: center; }
.invite-hero-image { display: block; width: min(100%, 360px); height: auto; margin: 0 auto 18px; }
.eyebrow { display: block; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; margin-bottom: 16px; }
.invite-header h1 { font-size: clamp(1.9rem, 4vw, 2.8rem); font-weight: 700; line-height: 1.2; letter-spacing: -.035em; margin-bottom: 18px; }
.invite-header > p { color: #637269; line-height: 1.7; margin: 0; }
.invite-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: start; }
.reward-card { padding: 28px; border: 1px solid #dce9dc; border-radius: 20px; background: #edf5eb; }
.reward-image { display: block; width: 120px; height: auto; margin: -10px 0 14px; }
.reward-card .eyebrow { margin-bottom: 10px; }
.reward-card h2 { font-size: 1.8rem; font-weight: 700; letter-spacing: -.025em; margin-bottom: 12px; }
.reward-card > p:not(.eyebrow) { color: #516556; line-height: 1.7; font-size: .95rem; }
.friend-benefit { display: flex; align-items: center; gap: 12px; border-top: 1px solid #d5e4d4; padding-top: 18px; margin-top: 20px; font-size: .9rem; line-height: 1.6; }
.friend-benefit i { color: var(--brand-link); }
.invite-steps { padding: 28px 4px 0; }
.invite-steps h2 { font-size: 1.05rem; font-weight: 700; margin-bottom: 20px; }
.invite-steps ol { list-style: none; padding: 0; margin: 0; }
.invite-steps li { display: flex; gap: 14px; margin-bottom: 18px; }
.invite-steps li:last-child { margin-bottom: 0; }
.invite-steps li > span { flex-shrink: 0; display: flex; justify-content: center; align-items: center; width: 28px; height: 28px; border: 1px solid #dce5dd; border-radius: 50%; color: var(--brand-link); font-size: .8rem; font-weight: 600; background: #fff; }
.invite-steps h3 { font-size: .9rem; font-weight: 600; margin: 3px 0 5px; }
.invite-steps p { font-size: .85rem; color: #637269; line-height: 1.6; margin: 0; }
.invite-form-card { background: #fff; border: 1px solid #e4eae4; border-radius: 20px; padding: 32px; box-shadow: 0 12px 40px rgba(36, 56, 46, .04); }
.invite-form-card h2 { font-size: 1.35rem; font-weight: 700; margin-bottom: 10px; letter-spacing: -.02em; }
.form-intro { color: #637269; font-size: .9rem; line-height: 1.6; margin-bottom: 28px; }
.invite-form-card label { display: block; font-size: .82rem; font-weight: 600; margin-bottom: 8px; }
.name-fields, .phone-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.name-fields > div, .phone-fields > div { min-width: 0; }
.phone-fields { grid-template-columns: 100px minmax(0, 1fr); }
.invite-field { margin-top: 20px; }
.invite-form-card .form-control { min-height: 48px; border-color: #d9e2da; border-radius: 10px; font-size: .9rem; background: #fff; color: #24382e; }
.invite-form-card .form-control::placeholder { color: #7a857e; }
.invite-form-card .form-control:focus { border-color: var(--brand-primary); box-shadow: 0 0 0 3px rgba(79, 183, 72, .12); }
.contact-help { font-size: .8rem; color: #637269; line-height: 1.6; margin: 12px 0 24px; }
.invite-submit { display: flex; justify-content: center; align-items: center; gap: 12px; width: 100%; min-height: 50px; background: var(--brand-link); color: #fff; border-radius: 10px; font-size: .95rem; font-weight: 600; }
.invite-submit:hover, .invite-submit:active { background: var(--brand-primary-hover); color: #fff; }
.invite-submit:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
.invite-submit:disabled { background: var(--brand-link); color: #fff; opacity: .7; }
.invite-note { font-size: .77rem; text-align: center; line-height: 1.6; color: #637269; margin: 16px 0 0; }
.campaign-note { max-width: 820px; margin: 32px auto 0; text-align: center; font-size: .78rem; line-height: 1.7; color: #637269; }
@media (max-width: 767.98px) {
  .invite-page { padding: 32px 0 24px; }
  .invite-header { margin-bottom: 28px; }
  .invite-hero-image { width: min(100%, 280px); margin-bottom: 14px; }
  .reward-image { width: 100px; }
  .invite-layout { grid-template-columns: 1fr; gap: 28px; }
  .reward-card, .invite-form-card { padding: 24px; }
}
@media (max-width: 359.98px) {
  .name-fields { grid-template-columns: 1fr; }
  .reward-card, .invite-form-card { padding: 18px; }
  .phone-fields { grid-template-columns: 85px minmax(0, 1fr); gap: 10px; }
}
</style>
